import * as React from 'react';
import posed, { PoseGroup } from 'react-pose';
import styled from 'styled-components';
import { IPanelProps } from './types';

const PanelWrapper = styled.div``;

const PaneDiv = styled.div`
  overflow: hidden;
`;

const Panel: React.FCC<IPanelProps> = (props) => {
  // The total time for the transition animation
  const TRANSITION_DURATION = props.transitionDuration || 250;
  // The time for each *step* of the transition
  const TRANSITION_STEP_DURATION = TRANSITION_DURATION / 2;

  /*
   * The secret sauce for this transition is flipMove: false, which disables the
   * default behavior of switching an exiting element to position: absolute. We
   * need elements to stay in the document flow so that they can keep their
   * container open as they transition their height.
   */
  const Pane = posed(PaneDiv)({
    /* tslint:disable: object-literal-sort-keys */
    enter: {
      opacity: 1,
      height: 'auto',
      delay: TRANSITION_STEP_DURATION,
      transition: {
        opacity: {
          // When entering, the opacity step happens second
          delay: TRANSITION_STEP_DURATION,
          duration: TRANSITION_STEP_DURATION,
        },
        height: {
          // And the height animation happens first, while the content is still invisible
          duration: TRANSITION_STEP_DURATION,
        },
      },
    },
    exit: {
      opacity: 0,
      height: 0,
      transition: {
        // When exiting, it should fade out first
        opacity: { duration: TRANSITION_STEP_DURATION },
        height: {
          delay: TRANSITION_STEP_DURATION,
          // *then* transition its height
          duration: TRANSITION_STEP_DURATION,
        },
      },
    },
    /* tslint:enable: object-literal-sort-keys */
  });
  return (
    <PanelWrapper>
      <PoseGroup flipMove={false}>
        {React.Children.map(props.children, (child, i) => (child ? <Pane key={i}>{child}</Pane> : undefined))?.filter(
          (a) => !!a,
        )}
      </PoseGroup>
    </PanelWrapper>
  );
};

export default Panel;
